import { styled } from "@mui/system";
import { Box } from "@mui/system";
import React from "react";
interface MainWrapperProps {
  children: React.ReactNode;
}
const MainContent = styled(Box)`
  ${({ theme }: any) => `
  position: relative;
  flex-grow: 1;
  padding: 12px;
  margin-bottom: 60px;
  transition: ${theme.transitions.create(["margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  })};
  @media screen and (min-width: 600px) {
     
        max-width: 1200px;
        margin: 0 auto;
        width: 80vw;
        padding: 24px;
  }
  `}
`;

export const MainWrapper = ({ children }: MainWrapperProps) => {
  return (
    <Box sx={{ display: "flex" }}>
      <MainContent>{children}</MainContent>
    </Box>
  );
};
